import { render, staticRenderFns } from "./CommonTree.vue?vue&type=template&id=70b5d006&scoped=true"
import script from "./CommonTree.vue?vue&type=script&lang=js"
export * from "./CommonTree.vue?vue&type=script&lang=js"
import style0 from "./CommonTree.vue?vue&type=style&index=0&id=70b5d006&prod&lang=less&scoped=true"
import style1 from "./CommonTree.vue?vue&type=style&index=1&id=70b5d006&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b5d006",
  null
  
)

export default component.exports